export default "__VITE_ASSET__1vnrPn$i__"